export const baseURL = process.env.REACT_APP_API_BASE;
export const defaultOptions = token => ({
  baseURL,
  headers: { Authorization: `Bearer ${token}` }
});

// The API's error message, or `fallback` when there is none (e.g. offline).
export const apiErrorMessage = (error, fallback) => {
  const message = error.response?.data?.message;
  return Array.isArray(message) ? message.join(" ") : message || fallback;
};
